<form [formGroup]="ballotForm">
  <div id="iec-finalise-ballot-modal" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
    <div id="iec-modal-content" class="relative p-6 bg-white rounded-lg shadow-lg w-[800px] h-[250px]">
      <!-- Close Button -->
      <button id="iec-modal-close-button" class="absolute right-4 top-4 p-2" (click)="cancel()">
        <span id="iec-modal-close-icon" class="text-3xl material-symbols-rounded text-grey-800">close</span>
      </button>

      <div class="p-2">
        <p id="iec-modal-header" class="mt-2 text-4xl text-left">Finalise Ballot </p>
        <!-- Radio Button Group -->
        <div *ngIf="isTwoValidOptions" id="iec-radio-group" class="flex items-center justify-between my-4">
          <label class="flex items-center space-x-2 w-1/2" id="label-{{ defaultOption.id }}">
            <input type="radio" id="radio-button-{{ defaultOption.id }}" formControlName="ballotResponse" [value]="defaultOption.name" class="w-6 h-6 accent-black focus:ring-black"
              checked>
            <span [ngStyle]="{'color': defaultOption.color}" class="material-symbols-rounded" id="icon-{{ defaultOption.id }}">
              {{ defaultOption.icon }}
            </span>
            <span class="text-2xl font-normal" id="text-{{ defaultOption.id }}">
              {{ defaultOption.text }}
            </span>
          </label>
          <label class="flex items-center space-x-2 w-1/2" id="label-{{ abstain.id }}">
            <input type="radio" formControlName="ballotResponse" value="abstain" class="w-6 h-6 accent-black focus:ring-black" id="radio-button-{{ abstain.id }}">
            <span [ngStyle]="{'color': abstain.color}" class="material-symbols-rounded" id="icon-{{ abstain.id }}">
              {{ abstain.icon }}
            </span>
            <span class="text-2xl font-normal" id="text-{{ abstain.id }}">
              {{ abstain.text }}
            </span>
          </label>
        </div>


        <div *ngIf="isVoteTiedForFinalisation" id="iec-radio-group" class="flex items-center justify-between my-4">
          <label class="flex items-center space-x-2 w-1/3"  id="label-{{ inFavourOf.id }}">
            <input type="radio" formControlName="ballotResponse" id="radio-button-{{ inFavourOf.id }}" [value]="inFavourOf.name" class="w-6 h-6 accent-black focus:ring-black" checked>
            <span [ngStyle]="{'color': inFavourOf.color}" class="material-symbols-rounded" id="icon-{{ inFavourOf.id }}">
              {{ inFavourOf.icon }}
            </span>
            <span class="text-2xl font-normal" id="text-{{ inFavourOf.id }}">
              {{ inFavourOf.text }}
            </span>
          </label>

          <label class="flex items-center space-x-2 w-1/3" id="label-{{ against.id }}">
            <input type="radio" formControlName="ballotResponse" id="radio-button-{{ against.id }}" [value]="against.name" class="w-6 h-6 accent-black focus:ring-black">
            <span [ngStyle]="{'color': against.color}" class="material-symbols-rounded" id="icon-{{ against.id }}">
              {{ against.icon }}
            </span>
            <span class="text-2xl font-normal" id="text-{{ against.id }}">
              {{ against.text }}
            </span>
          </label>

          <label class="flex items-center space-x-2 w-1/3" id="label-{{ abstain.id }}">
            <input type="radio" formControlName="ballotResponse"  id="radio-button-{{ abstain.id }}" [value]="abstain.name" class="w-6 h-6 accent-black focus:ring-black">
            <span [ngStyle]="{'color': abstain.color}" class="material-symbols-rounded" id="icon-{{ abstain.id }}">
              {{ abstain.icon }}
            </span>
            <span class="text-2xl font-normal" id="text-{{ abstain.id }}">
              {{ abstain.text }}
            </span>
          </label>
        </div>

        <div *ngIf="hasMajorityAbstain" id="iec-radio-group" class="flex items-center justify-between my-4">
          <label class="flex items-center space-x-2 w-1/2 " id="label-{{ abstain.id }}">
            <span [ngStyle]="{'color': abstain.color}" class="material-symbols-rounded" id="icon-{{ abstain.id }}">
              {{ abstain.icon }}
            </span>
            <span class="text-2xl font-normal" id="text-{{ abstain.id }}">
              {{ abstain.text }}
            </span>
          </label>
        </div>

        <!-- Footer Buttons -->
        <div id="iec-modal-footer" class="flex justify-between mt-6">
          <button id="iec-modal-cancel-button" (click)="cancel()"
            class="border border-gray-300 rounded-lg px-4 py-4 w-[calc(50%-0.5rem)] mr-2 hover:bg-gray-100 text-xl">
            Cancel
          </button>
          <button id="iec-modal-confirm-button" (click)="confirm()"
            class="btn btn-primary rounded-lg px-4 py-4 w-[calc(50%-0.5rem)] ml-2 text-xl">
            Finalise
          </button>
        </div>

      </div>

    </div>
  </div>
</form>
